import { bindEvents, getRootOffsetBounds } from '../helpers';

import AnimationController from './animation';
import ScrollController from './scroll';

// modules

class CursorController {

	constructor() {

		this.el = {
			container: null
		};

		// class variable groups

		this.bounds = {
			container: null
		};

		this.controllers = {
			animation: null
		};

		this.coords = {
			clientX: 0,			// relative to window viewport
			clientY: 0,
			pageX: 0,			// relative to document
			pageY: 0,
			scrollX: 0,
			scrollY: 0
		};

		this.flags = {
			isInitialized: false
		};

		// class variables

		// bind event to class scope
		this.events = bindEvents(this);
	}

	// initialize

	initialize(container = document.body) {
		if (!this.flags.isInitialized) {
			this.flags.isInitialized = true;

			this.el = { container };

			this.addEventListeners();
			this.measure();
		}
	}

	// event listeners

	addEventListeners() {
		window.addEventListener('mousemove', this.events._onMouseMove);

		this.controllers.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		});
	}

	removeEventListeners() {
		window.removeEventListener('mousemove', this.events._onMouseMove);
		AnimationController.clear(this.controllers.animation);
	}

	// listener methods

	_onMouseMove(e) {
		this.measureCursor(e);
	}

	update() {
		this.coords.scrollX = this.coords.clientX;
		this.coords.scrollY = this.coords.clientY + ScrollController.position;
	}

	render() {

	}

	// general methods

	measure() {
		this.bounds.container = getRootOffsetBounds(this.el.container);
	}

	measureCursor(e) {
		if (e) {
			this.coords.clientX = e.clientX;
			this.coords.clientY = e.clientY;
			this.coords.pageX = e.pageX;
			this.coords.pageY = e.pageY;
			this.coords.scrollX = e.clientX;
			this.coords.scrollY = e.clientY + ScrollController.position;
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}

export default new CursorController();
